'use client';

import { Card as AntdCard } from 'antd';
import type { ReactNode } from 'react';

type CardProps = {
  title: string;
  description?: string;
  children?: ReactNode;
};

export function Card({ title, description, children }: CardProps) {
  return (
    <AntdCard
      title={<span className="text-base font-semibold text-slate-900">{title}</span>}
      bordered
      className="shadow-sm"
      extra={
        description ? <span className="text-xs text-slate-500 leading-tight">{description}</span> : null
      }
    >
      {children}
    </AntdCard>
  );
}

